<template>
  <div class="home-wrap">
    <nav-header :activeIndex="0" />
    <header class="home-wrap-header">
      <div class="dialog"></div>
      <img src="../../assets/banner/pic-home-banner.png" alt="">
      <img src="./assets/icon-arrow.svg" class="icon-arrow" alt="">
      <div class="banner-inner">
        <p class="banner-inner-title">「圣诉」律师</p>
        <p class="banner-inner-content">让优质的法律服务触手可及</p>
        <div class="banner-inner-btns">
          <router-link :to="{name: 'home-service'}" class="banner-inner-btns-understand">了解圣诉服务</router-link>
          <router-link :to="{name: 'join-us-detail', query: {type: 'lawyer'}}" class="banner-inner-btns-become">成为圣诉律师</router-link>
        </div>
      </div>
    </header>
    <main class="home-wrap-content">
      <section class="home-wrap-content-sec">
        <div class="home-wrap-content-sec-what">
          <div class="line"></div>
          <div class="title">我们能为您做什么</div>
          <div class="home-wrap-content-sec-what-domain-wrap">
            <router-link tag="div" v-for="(item, index) in field" :key="index"
                         :to="{name: 'field-detail', query: {id: item.id}}"
                         class="home-wrap-content-sec-what-domain-wrap-item">
              <div class="normal-dialog">
                <div class="black-dialog"></div>
                <p>{{item.title}}</p>
              </div>
              <img :src="item.imgUrl" alt="">
              <div class="transition-box">
                <div class="black-dialog">
                  <span>{{item.title}}</span>
                  <b v-for="(service, index) in item.servicePlan" :key="index">· {{service.title}}</b>
                </div>
              </div>
            </router-link>
            <router-link tag="div" :to="{name: 'home-service'}" class="home-wrap-content-sec-what-domain-wrap-item more-domain">更多领域服务</router-link>
          </div>
        </div>
      </section>
      <select-us />
      <lawyer-list :lawyerList="lawyerList" @getCity="getCity" style="background-color: #f7f7f7">
        <router-link tag="div" :to="{name: 'home-lawyer'}" class="home-wrap-content-sec-lawyer-btn">查看更多律师</router-link>
      </lawyer-list>
      <div class="consultation">
        <div class="consultation-title">咨询服务</div>
        <div class="consultation-content" @click="consultationRouter">
          <div>
            <span>电话咨询</span>
            <span style="color: red">¥ 500 元</span>
          </div>
          <div>为您深度分析法律问题，提供权威解决方案</div>
        </div>
        <div class="consultation-content">
          <div>
            <span>定制合同</span>
            <span style="color: red">¥ 200 元</span>
          </div>
          <div>为您提供权严谨无法律风险的优质合同</div>
        </div>
      </div>
    </main>
    <div v-if="isScrollTop" class="scroll-top">
      <div class="service-wrap" @click="getService">
        <img src="./assets/icon-assistant.svg" alt="">
        <span>联系客服</span>
      </div>
      <div class="scroll-wrap" @click="backToTop">
        <img src="./assets/icon-arrow-up-2.svg" alt="">
        <span>回到顶部</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { Message } from 'element-ui/lib'
  import Icon from '@/common-components/icon'
  import LawyerList from '@/common-components/lawyer-list'
  import SelectUs from '@/common-components/select-us'
  import NavHeader from '@/common-components/nav-header'
  import { clickShowMeiQia } from '@/utils/meiqia'
  import $ from 'jquery'
  import api from './api'
  export default {
    name: 'home',
    components: {
      Icon, LawyerList, SelectUs, NavHeader
    },
    data () {
      return {
        field: [
          {title: '房产纠纷',
            id: 'DE0CA56E-E967-4DDD-9A23-AD6EBC285F30',
            imgUrl: 'https://testcontract.alphalawyer.cn/cart/20190907/4188d89375df4098862d5986996591c2.png?Expires=2198982317&OSSAccessKeyId=LTAIq6AOvnGAg287&Signature=x%2Fm95un42RL7npeKznJBf7pyktM%3D'},
          {title: '合同纠纷',
            id: 'B6736053-3D9F-4593-9905-A913169F63AC',
            servicePlan: [{title: '合同审查'}, {title: '加盟维权'}],
            imgUrl: 'https://testcontract.alphalawyer.cn/cart/20190907/28c911e295714a8aa1245031c21cea0f.png?Expires=2198982115&OSSAccessKeyId=LTAIq6AOvnGAg287&Signature=64uI7Vxpio2U94UCK4TB0xWhNlg%3D'},
          {title: '债权债务',
            id: 'B1180304-2905-4CD0-BBCF-695A9641E00D',
            servicePlan: [{title: '抵押担保'}, {title: '民间借贷'}],
            imgUrl: 'https://testcontract.alphalawyer.cn/cart/20190907/425be142a9ab490c844964cdd1a8a8f6.png?Expires=2198982399&OSSAccessKeyId=LTAIq6AOvnGAg287&Signature=I1cJNt1kJNdV9Lidw7YNKiWGqnU%3D'},
          {title: '婚姻家庭',
            id: 'B7AC75DD-6163-48D9-89A4-E88A3DEEBD84',
            servicePlan: [{title: '离婚'}, {title: '继承'}],
            imgUrl: 'https://testcontract.alphalawyer.cn/cart/20190907/d067223f9ddb41a9b539e9212a35a8e6.png?Expires=2198982229&OSSAccessKeyId=LTAIq6AOvnGAg287&Signature=v%2BXR4A%2Fc4zUni2c9IDsyu41%2BEk0%3D'},
          {title: '刑事辩护',
            id: 'F0F9C7F8-AA04-4703-929B-F8FB1DC447CF',
            servicePlan: [{title: '取保候审'}, {title: '暴力犯罪'}, {title: '经济犯罪'}, {title: '职务犯罪'}],
            imgUrl: 'https://testcontract.alphalawyer.cn/cart/20190907/b3ca8e8f3dfe48f1b31cf9699de0c774.png?Expires=2198982185&OSSAccessKeyId=LTAIq6AOvnGAg287&Signature=dCb8dLvbWUHHE6YZo3aU14lQ4Ok%3D'}
        ],
        lawyerList: [],
        location: '',
        isScrollTop: false
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      consultationRouter () {
        this.$router.push({path: `/consultation`})
      },
      // 获取地理位置
      getCity (city) {
        this.location = city
        this.getPositionLawyer()
      },
      // 获取律师列表
      async getPositionLawyer () {
        let obj = {
          pageIndex: 1,
          pageSize: 3,
          city: this.location
        }
        let res = await api.getPositionLawyerList(obj)
        if (res.data.isSuccess) {
          this.lawyerList = res.data.data.list
        } else {
          Message.error(res.data.resultMsg)
        }
      },
      // 回到顶部
      backToTop () {
        $(document.documentElement).animate({
          scrollTop: 0
        }, 500)
      },
      handleScroll () {
        let top = document.documentElement.scrollTop || document.body.scrollTop
        if (top > 760) {
          this.isScrollTop = true
        } else {
          this.isScrollTop = false
        }
      },
      // 连接商桥
      getService () {
        clickShowMeiQia()
      }
    }
  }
</script>

<style lang='stylus' scoped>
  @import '../../styles/constant.styl'
  .consultation {
    width: 9.6rem
    margin: 0 auto
    padding: .5rem 0
    &-title {
      height: 0.5rem
      border-left: 0.04rem solid #ed6c00
      font-size: 0.36rem
      padding-left: 0.16rem
    }
    &-content {
      padding: .3rem
      margin-top: .2rem
      border: .01rem solid rgb(247, 247, 247)
      cursor: pointer
    }
  }
  .home-wrap
    &-header {
      width: 100%
      height: 7.6rem
      position relative
      img {
        width: 100%
        height: 100%
      }
      .icon-arrow {
        width: .64rem
        height: .64rem
        position: absolute;
        bottom: .16rem
        left 50%
        transform translateX(-50%)
      }
      .dialog {
        width: 100%
        height: 7.6rem
        background #000
        position absolute
        top 0
        left 0
        opacity .5
      }
      .banner-inner {
        color: #fff
        position absolute
        top 2.91rem
        left 2.2rem
        &-title {
          font-size: .6rem;
          font-weight: 6rem;
        }
        &-content {
          margin .08rem 0 .24rem .32rem
          font-size: .36rem
          font-weight: 300
        }
        &-btns {
          display flex
          margin-left .32rem
          a {
            width: 2.16rem;
            height: .48rem;
            line-height .48rem
            text-align center
            font-size: .16rem;
            font-weight: 500;
          }
          &-understand {
            background-color: #ffffff;
            color: #1d1b1b;
            margin-right .24rem
          }
          &-become {
            font-size: .16rem;
            color: #fff
            border .01rem solid #fff
          }
        }
      }
    }
    &-content {
      &-sec {
        width: 100%
        background #f7f7f7
        &-what {
          width: 9.6rem
          margin 0 auto
          padding .8rem 0 .60rem 0
          &-domain-wrap {
            display flex
            flex-wrap wrap
            justify-content space-around
            &-item {
              width: 3rem
              height: 3rem
              margin-bottom .2rem
              position relative
              text-align center
              cursor pointer
              z-index 99
              img {
                width: 100%
                height: 100%
              }
              .black-dialog, p {
                width: 100%
                height: 100%
                position absolute
                top 0
                left 0
                background #000
                opacity .5
                color #ffffff
                font-size: .36rem
                cursor pointer
                display flex
                flex-direction column
                justify-content center
              }
              p {
                opacity 1
                background none
              }
              .normal-dialog {
                display block
              }
              .transition-box {
                width: 100%
                height: 100%
                position absolute
                top 0
                left 0
                opacity: .8
                background: #ed6c00;
                display: none
                .black-dialog {
                  width: 2.59rem
                  height: 2.59rem
                  margin .2rem .2rem .21rem .21rem
                  border .01rem solid #fff
                  background: #ed6c00
                  display flex
                  opacity 1
                  flex-direction column
                  justify-content center
                  span {
                    color: #fff
                    margin-bottom .20rem
                  }
                  b {
                    line-height .33rem
                    font-size: .24rem
                    color: #fff
                    margin-left -.15rem
                  }
                }
                .concat-wrap-title {
                  margin .62rem 0 .32rem 0
                  font-size: .36rem
                }
              }
            }
            &-item:hover {
              .normal-dialog {
                display: none
              }
              .transition-box {
                display: block
              }
            }
            .more-domain {
              border: solid .01rem #fdba78;
              color: #fdba78;
              font-size: .24rem
              line-height 3rem
            }
          }
        }
        .line {
          width: 1.32rem;
          height: .04rem;
          margin: 0 auto .32rem
          background-color: #ed6c00;
        }
        .title  {
          height: .5rem;
          font-size: .36rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #000000;
          text-align center
          margin-bottom .48rem
        }
      }
    }
    .scroll-top {
      width: .44rem
      height: .88rem
      background-color: #ffffff
      position fixed
      right 1rem
      bottom 2rem
      cursor pointer
      img {
        width: .32rem
        height: .32rem
      }
      .service-wrap, .scroll-wrap {
        width: .44rem
        height: .44rem
        display flex
        flex-direction column
        align-items center
        justify-content center
        border: solid 1px #e1e1e1
        img {
          display block
        }
        span {
          font-size: .12rem
          display none
          background-color #a9a9a9
          color #fff
          padding .06rem .1rem
        }
      }
      .service-wrap:hover, .scroll-wrap:hover {
        border 0
        img {
          display: none
        }
        span {
          display: block
        }
      }
      .service-wrap {
        border-bottom 0
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue